import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Divider as Divider$1 } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { CustomPropTypes } from '@zillow/zrs-cms';

var BlockDivider = function BlockDivider(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  var _attrs$appearance = attrs.appearance,
    appearance = _attrs$appearance === void 0 ? 'regular' : _attrs$appearance,
    _attrs$length = attrs.length,
    length = _attrs$length === void 0 ? {
      default: 'auto'
    } : _attrs$length,
    _attrs$margin = attrs.margin,
    margin = _attrs$margin === void 0 ? {
      marginBottom: {
        default: 'sm'
      }
    } : _attrs$margin;
  return /*#__PURE__*/React.createElement(Divider$1, _extends({
    key: index,
    appearance: appearance,
    length: length,
    orientation: {
      default: 'horizontal',
      lg_lte: 'horizontal',
      sm_lte: 'horizontal'
    }
  }, margin));
};
BlockDivider.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    appearance: PropTypes.string,
    length: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    margin: PropTypes.shape({
      marginBottom: CustomPropTypes.inlineMediaQuery(PropTypes.string),
      marginTop: CustomPropTypes.inlineMediaQuery(PropTypes.string)
    })
  }),
  index: PropTypes.number
} : {};
var Divider = BlockDivider;

export { Divider as default };
